import { useCallback } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorFundEscrowList = () => {
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)

  const fundEscrowSearch = useCallback(
    (payload, callback, loading) => {
      let payloadRequest = { ...payload, keywords: { source: 'SELLER', account_uid: account.uid } }
      ApiService.jsonRequest('/fund-escrow/search', payloadRequest, (response) => {
        loading(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          callback({
            data: response.data?.items,
            pagination: {
              currentPage: pages.page,
              limitProduct: pages.limit,
              totalPages: pages.total_pages,
              totalItem: pages.total_items,
            },
          })
        } else {
          callback({
            data: null,
            pagination: {
              currentPage: payload.page,
              limitProduct: payload.limit,
              totalPages: 0,
              totalItem: 0,
            },
          })
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  const fundEscrowSummary = useCallback(
    (payload, callback, loading) => {
      let payloadRequest = { ...payload, source: 'SELLER', recipient_account_uid: account.uid }
      ApiService.jsonRequest('/fund-escrow/summary', payloadRequest, (response) => {
        loading(false)
        if (response.status_code === 200) {
          callback({
            escrowPending: response.data.total_escrow_pending,
            escrowCompleted: response.data.total_escrow_completed,
            escrowCancelled: response.data.total_escrow_cancelled,
          })
        } else {
          callback({
            escrowPending: 0,
            escrowCompleted: 0,
            escrowCancelled: 0,
          })
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  return {
    fundEscrowSearch,
    fundEscrowSummary,
  }
}

export default InteractorFundEscrowList
